module.exports = __webpack_public_path__ + "static/whiteroom_logo@2-5e6e3e690eaefc90fa8613c90092e4c0.png";